import i18n from "./i18n";

// Translates server-driven toast messages.
//
// The backend returns English `message` strings. We map each known message to a
// translation key so the toast is shown in the user's selected language. If the
// backend ever starts sending a `messageKey` directly, that takes precedence.
// Anything unmapped falls back to the raw server message, so nothing is lost.
const KEY_BY_MESSAGE = {
  // users
  "User Successfully created!": "userCreated",
  "Failed to create user.": "userCreateFailed",
  "User deleted successfully": "userDeleted",
  "User not found or not deleted": "userNotFoundOrNotDeleted",
  "User Successfully updated!": "userUpdated",
  "Failed to update user.": "userUpdateFailed",
  "Failed to fetch users.": "usersFetchFailed",
  // auth
  "Wrong username or password. You are not authorized.": "wrongCredentials",
  "This user do not exist!": "userDoesNotExist",
  "Wrong password!": "wrongPassword",
  "Login failed.": "loginFailed",
  "Successsfully logged in!": "loginSuccess",
  "Successfully logged out.": "logoutSuccess",
  // cities / designs
  "City successfully Deleted.": "cityDeleted",
  "Design successfully Deleted.": "designDeleted",
  // elements
  "New element has been created!": "elementCreated",
  "Element updated successfully!": "elementUpdated",
  "Element successfully Deleted.": "elementDeleted",
  "Unable to update, missing image file!": "elementUpdateNoImage",
  "Element not found, updating failed!": "elementNotFound",
  // likes / votes
  "You have successfully voted for this design!": "voteSuccess",
  "You have already voted for this design!": "alreadyVoted",
};

// Accepts a response/error payload (response.data or err.response.data) and
// returns a localized, user-facing string.
export const serverMessage = (payload) => {
  const message = typeof payload?.message === "string" ? payload.message : "";
  const key = payload?.messageKey || KEY_BY_MESSAGE[message.trim()];
  return key ? i18n.t(key, { defaultValue: message }) : message;
};
